import { contains, head } from 'ramda';
import { ComponentEnhancer, compose, setDisplayName, withProps, withStateHandlers } from 'recompose';
import { Layout } from '../../../constants/Layout';
import { toLayout, toSettingsLayout } from '../../layout';
import { withMMGRSettings, withoutMMGRSettings } from '../withMMGRSettings';
import { IMMGRSettingsProps } from '../withMMGRSettings/withMMGRSettings.types';
import {
  IState,
  IWithLayoutAndSortInner,
  IWithLayoutAndSortOuter,
  TStateUpdaters,
  TWithLayoutAndSort,
} from './withLayoutAndSort.types';

export const withLayoutAndSort = ({
  layouts = [Layout.Gallery, Layout.List],
}: TWithLayoutAndSort = {}): ComponentEnhancer<IWithLayoutAndSortInner, IWithLayoutAndSortOuter> =>
  compose<IWithLayoutAndSortInner, IWithLayoutAndSortOuter>(
    setDisplayName('withLayoutAndSort'),
    withProps({ layouts }),
    withMMGRSettings,
    withStateHandlers<IState, TStateUpdaters, IWithLayoutAndSortOuter & IMMGRSettingsProps & { layouts: Layout[] }>(
      ({ mmgrSettings, layouts }) => {
        const { layout: mmgrSettingsLayout, sort } = mmgrSettings;

        const initialLayout = toLayout(mmgrSettingsLayout);
        const layout = contains(initialLayout, layouts) ? initialLayout : head(layouts);

        return {
          layout,
          settingsLayout: toSettingsLayout(layout),
          sort,
        };
      },
      {
        setLayout: () => (layout) => ({ layout }),
        setSort: () => (sort) => ({ sort }),
      },
    ),
    withoutMMGRSettings,
  );
